import React from 'react';

const Sitemap = () => (
  <main>
    <ul>
      <li>
        <a href="/portfolio">Daniel Rubio Portfolio</a>
      </li>
      <li>
        <a href="/videos">Daniel Rubio Tutorial Videos</a>
      </li>
      <li>
        <a href="/contact">Contact Daniel Rubio</a>
      </li>
    </ul>
  </main>
);

export default Sitemap;



// WEBPACK FOOTER //
// ./src/components/Sitemap.js